import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { Field } from 'formik';
import CommonContainer from '../../containers/Common';
import { Select } from '@material-ui/core';

interface Props {
  makerCode: string | undefined,
  onChange: (makerCode: string) => void,
}

export default ((props) => {
  const commonContainer = CommonContainer.useContainer();
  const makerCode = props.makerCode || commonContainer.makers[0].makerCode;

  const handleChange = (value: string) => {
    if (props.makerCode !== value) {
      props.onChange(value);
    }
  };


  return (
    <Field style={{ fontSize: 13, }} required fullWidth name='maker' label='Maker' id='maker' value={makerCode} onChange={(event: React.ChangeEvent<HTMLSelectElement>) => handleChange(event.target.value as string)} component={Select}>
      {commonContainer.makers.map(maker => (
        <MenuItem key={maker.makerCode} value={maker.makerCode}>{maker.makerName}</MenuItem>)
      )}
    </Field>
  );
}) as React.FC<Props>;
